import React, { useState, useEffect } from 'react';
import { CheckCircle, HourglassEmpty, Cancel, RadioButtonChecked } from '@material-ui/icons';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import ReactTable from 'components/ReactTable/ReactTable';
import { currency, nDecimal } from 'hooks/Pipe';
import { wsGetAll } from 'services/WService';
import Badge from 'components/Badge/Badge';
import moment from 'moment';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 120 },
  { Header: 'Estado', accessor: 'state', excelEnabled: false, width: 130 },
  { Header: 'HR', accessor: 'id', width: 80 },
  { Header: 'Liquidación', accessor: 'liquidate_date', width: 180 },
  { Header: 'Inicio Liq.', accessor: 'liquidate_date_start', width: 140 },
  { Header: 'Fin Liq.', accessor: 'liquidate_date_end', width: 140 },
  { Header: 'Avance', accessor: 'advance', width: 80 },
  { Header: 'Zona', accessor: 'zone', width: 80 },
  { Header: 'Vehiculo', accessor: 'codeVehicle', width: 90 },
  { Header: 'Jefe reparto', accessor: 'distManager' },
  { Header: 'Enc. mercadería', accessor: 'distInventoryManager' },
  { Header: 'Programación', accessor: 'scheduledDate', width: 135 },
  { Header: 'Despacho', accessor: 'dispatchDate', width: 135, align: 'right' },
  { Header: 'Monto', accessor: 'amount', width: 100, align: 'center' },
  { Header: 'Cli.', accessor: 'customers', width: 60, align: 'right' },
  { Header: 'Peso', accessor: 'weight', width: 70, align: 'right' },
  { Header: 'Vol.', accessor: 'volume', width: 70, align: 'right' },
  { Header: 'Nombre almacén', accessor: 'warehouse', width: 215 },
  { Header: 'Ult. Proceso', accessor: 'processDate', width: 150 },
  { Header: 'Mensaje error', accessor: 'errorMessage', width: 150 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

const listStates = [
  { id: 'N', name: 'Creado', color: 'info', icon: <RadioButtonChecked /> },
  { id: 'G', name: 'Generado', color: 'info', icon: <RadioButtonChecked /> },
  { id: 'A', name: 'Anulado', color: 'danger', icon: <Cancel /> },
  { id: 'F', name: 'Facturado', color: 'warning', icon: <HourglassEmpty /> },
  { id: 'W', name: 'En Reparto', color: 'success', icon: <CheckCircle /> },
  {
    id: '1',
    name: 'Liq. de mercaderia',
    color: 'success',
    icon: <CheckCircle />,
  },
  {
    id: '2',
    name: 'Liq. de mercaderia +',
    color: 'success',
    icon: <CheckCircle />,
  },
  {
    id: '3',
    name: 'Liq. de documento',
    color: 'success',
    icon: <CheckCircle />,
  },
  {
    id: '4',
    name: 'Liq. de documento +',
    color: 'success',
    icon: <CheckCircle />,
  },
  { id: 'L', name: 'Liq. HR', color: 'success', icon: <CheckCircle /> },
  { id: '5', name: 'Cerrado', color: 'primary', icon: <Cancel /> },
];

function SettlementAdvance() {
  const [liquidation, setLiquidation] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  async function listLiquidations() {
    setDataLoading(true);
    let response = await wsGetAll('prog/sheet-distribution/liquidation');
    setDataLoading(false);
    if (response.success) setLiquidation(response.data);
  }

  useEffect(() => {
    listLiquidations();
  }, []);

  return (
    <CardContainer /*title="Avance de liquidación"*/ title={(<>Avance de liquidación {dataLoading && <LoadingSpinner />}</>)}>
      <ReactTable
        excelName="Listado de avance liquidación HR"
        defaultWidth={2500}
        columns={columns}
        data={liquidation.map((prog, i) => {
          return {
            num: i + 1,
            state: (
              <Badge
                color={
                  prog.state == 'A' && prog.sapAnnuled === 'P'
                    ? 'warning'
                    : listStates.findIndex((obj) => obj.id == prog.state) >= 0
                    ? listStates[listStates.findIndex((obj) => obj.id == prog.state)].color
                    : 'danger'
                }
              >
                {prog.state == 'A' && prog.sapAnnuled === 'P'
                  ? 'Anulando...'
                  : listStates.findIndex((obj) => obj.id == prog.state) >= 0
                  ? listStates[listStates.findIndex((obj) => obj.id == prog.state)].name
                  : '-'}
              </Badge>
            ),
            id: prog.id.toString(),
            liquidate_date:
              prog.liquidate_date !== null ? moment(prog.liquidate_date).format('DD/MM/YYYY hh:mm:ss') : '-',
            liquidate_date_start:
              prog.liquidate_date_start !== null
                ? moment(prog.liquidate_date_start).format('hh:mm:ss')
                : '-',
            liquidate_date_end:
              prog.liquidate_date_end !== null
                ? moment(prog.liquidate_date_end).format('hh:mm:ss')
                : '-',
            advance: prog.avance,
            zone: prog.base_zone_description,
            codeVehicle: prog.prog_vehicle_code,
            distManager: prog.manager_name,
            distInventoryManager: prog.inventory_manager_name,
            scheduledDate: prog.scheduled_date,
            dispatchDate: prog.dispatch_date,
            amount: currency(prog.amount),
            customers: prog.customers,
            weight: nDecimal(prog.weight),
            volume: nDecimal(prog.volume),
            warehouse: prog.logi_warehouse_name,
            processDate: prog.last_process_date,
            errorMessage: prog.error_message || '-',
            actions: '',
          };
        })}
      />
    </CardContainer>
  );
}

export default SettlementAdvance;
